import React, { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import './CompletedWork.css';
import { dashboardContext } from '../../../Dashboard';
import TextSkeleton from '../../../../../Components/Skeletons/TextSkeleton';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPrivilege } from '../../../../../utils/privileges';

const CompletedWork = () => {
    const navigate = useNavigate();
    const privileges = useSelector((state) => state?.privileges?.privileges)


    const { data, isLoading } = useContext(dashboardContext);
    // ---------------- NAVIGATION ---------------- //
    const handleViewNavigate = () => {
        navigate(`/worksites/schedule/overview`);
    };

    return (
        <Box className="completed-work-container">
            <div className='completed-work-header'>
                <span className="completed-work-title">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `Completed Schedules`}</span>
                {isLoading ? <TextSkeleton width="100%" fontSize="3rem" /> :
                    hasPrivilege(privileges, "Work site", 3, 2) &&
                    <span className="viewAll" onClick={handleViewNavigate}>
                        View All
                    </span>}
            </div>
            <Box className="completed-work-list">
                {data?.complted_schedules?.map((work, idx) => (
                    <React.Fragment key={idx}>
                        <div className="completed-work-item">
                            <Box className="completed-work-details">
                                <div className="completed-work-header">
                                    <span className="completed-work-label">{`${work?.scheduleCode || `N/A`} (${work?.siteName || `N/A`})`}</span>
                                    {/* <span className="completed-work-status work-status-completed">
                                        Completed
                                    </span> */}
                                </div>

                                <div className="completed-work-meta">
                                    <span className="completed-work-meta-item">
                                        Completed: {isLoading ? `Loading...` : `${work?.startDate || `N/A`}`}
                                    </span>
                                </div>
                            </Box>
                            {/* <button className="invoice-genrate-button">Genrate Invoice</button> */}
                        </div>
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    );
};

export default CompletedWork;
